// Textos del resultado "No corresponde": el aviso ANTES (el hueco se libera solo, hay
// que decirlo) y el resumen DESPUÉS con lo que el backend hizo de verdad. Mismo patrón
// que rescheduleSummary.js.
import { releasableEventId } from "./demoConstants";
import { formatDateTime } from "../../utils/localeFormat";

function slotLabel(iso, lang = "es") {
  return formatDateTime(iso, lang, {
    weekday: "short", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit",
  });
}

export function buildNoCorrespondeConfirm(demo, nowMs, t, lang = "es") {
  const lines = [t("translation:demos.noCorresponde.confirmTitle")];
  if (releasableEventId(demo, nowMs)) {
    lines.push(t("translation:demos.noCorresponde.confirmSlot", { slot: slotLabel(demo.scheduled_at, lang) }));
  }
  lines.push(t("translation:demos.noCorresponde.confirmLead"));
  lines.push(t("translation:demos.noCorresponde.confirmAsk"));
  return lines.join("\n\n");
}

// El backend devuelve `released: Boolean(evId)` (si la demo TENÍA hueco que liberar,
// no si lo consiguió: releaseLandingCalendar es no-fatal). Por eso "¿se liberó de
// verdad?" lo decide `release.calendar_rows > 0` (patrón de rescheduleSummary.js:34),
// no `resp.released` — si no, un Query fallido seguiría diciendo "Hueco liberado".
export function buildNoCorrespondeSummary(resp, t) {
  const rel = resp?.release || {};
  const lines = [t("translation:demos.noCorresponde.summaryTitle")];
  if (resp?.released) {
    if (rel.calendar_rows > 0) {
      lines.push(t("translation:demos.noCorresponde.summarySlotFreed"));
    } else {
      // Había hueco que liberar (evId existía) pero calendar_rows quedó en 0: el
      // Query/Update falló o no encontró filas. No es lo mismo que "no había nada".
      lines.push(t("translation:demos.noCorresponde.summarySlotFreeFailed"));
    }
    // El borrado de recordatorios corre siempre que hubo intento de liberar (es
    // independiente del resultado del calendario), así que se informa aparte.
    if (rel.reminders_error) {
      lines.push(t("translation:demos.noCorresponde.summaryRemindersError"));
    } else {
      lines.push(
        rel.reminders_deleted > 0
          ? t("translation:demos.noCorresponde.summaryRemindersDeleted")
          : t("translation:demos.noCorresponde.summaryNoReminders")
      );
    }
  } else {
    lines.push(t("translation:demos.noCorresponde.summaryNoSlot"));
  }
  lines.push(
    rel.lead_marked
      ? t("translation:demos.noCorresponde.summaryLeadMarked")
      : t("translation:demos.noCorresponde.summaryLeadNotMarked")
  );
  return lines.join("\n");
}
